//Reducer Types
interface State {
  faqList: any;
  staticPageList: any;
  staticPageCount: any;
  staticPageDetails: any;
  singleStaticPage: any; // You can replace `any` with a more specific type if available
}

interface StaticPageListSuccess {
  type: "STATIC_PAGE_LIST_SUCCESS";
  payload: any; // Replace `any` with the actual user data type if available
}

interface StaticPageDetailsSuccess {
  type: "STATIC_PAGE_DETAILS_SUCCESS";
  payload: any;
}

interface ClearStaticPageDetails {
  type: "CLEAR_STATIC_PAGE_DETAILS";
}

interface SingleStaticPageSuccess {
  type: "SINGLE_STATIC_PAGE_SUCCESS";
  payload: any;
}

interface FaqListSuccess {
  type: "FAQ_LIST_SUCCESS";
  payload: any; // Replace `any` with the actual user data type if available
}

type Action =
  | StaticPageListSuccess
  | StaticPageDetailsSuccess
  | ClearStaticPageDetails
  | SingleStaticPageSuccess
  | FaqListSuccess;

export const staticReducer = (
  state: State = {
    faqList: [],
    staticPageList: [],
    staticPageCount: 0,
    staticPageDetails: [],
    singleStaticPage: [],
  },
  action: Action
): State => {
  switch (action.type) {
    case "STATIC_PAGE_LIST_SUCCESS":
      return {
        ...state,
        staticPageList: action.payload.list,
        staticPageCount: action.payload.count,
      };
    case "STATIC_PAGE_DETAILS_SUCCESS":
      return {
        ...state,
        staticPageDetails: action.payload,
      };
    case "CLEAR_STATIC_PAGE_DETAILS":
      return {
        ...state,
        staticPageDetails: undefined,
      };
    case "SINGLE_STATIC_PAGE_SUCCESS":
      return {
        ...state,
        singleStaticPage: action.payload,
      };
    case "FAQ_LIST_SUCCESS":
      return {
        ...state,
        faqList: action.payload,
      };
    default:
      return state;
  }
};
